import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ContentComponents from '@uplight/marketplace-content';
import getUserMessages from '../shared/components/Boundary/getUserMessages';
import getGlobalFromWindow from '../shared/helpers/getGlobalFromWindow';
import { alertError } from '../shared/redux/actions/errors';


class Page extends Component {
  static getDomId() {
    return 'content_page';
  }

  constructor(props) {
    super(props);

    this.errorHandler = this.errorHandler.bind(this);
  }

  errorHandler(error, notify) {
    const { instanceId, csrf } = this.props;

    if (notify) {
      alertError(csrf, `Error for content with id ${instanceId}: ${error}`);
    }

    window.emitMarketplaceEvent(
      'showUserErrorMessage',
      getUserMessages(),
    );
  }

  render() {
    const { instanceId } = this.props;
    const siteId = getGlobalFromWindow('siteId');

    return (
      <ContentComponents.Page
        siteId={siteId}
        instanceId={instanceId}
        errorHandler={this.errorHandler}
      />
    );
  }
}

Page.propTypes = {
  instanceId: PropTypes.string.isRequired,
  csrf: PropTypes.string,
};

Page.defaultProps = {
  csrf: '',
};

export default Page;
